export const subpages = [
  {
    text: 'learnMore',
    scrollTo: 'meal-management',
  },
  {
    text: 'appStore',
    links: {
      en: 'https://apps.apple.com/en/app/workout-history/id6448888087',
      de: 'https://apps.apple.com/de/app/workout-history/id6448888087',
      es: 'https://apps.apple.com/es/app/workout-history/id6448888087',
      fr: 'https://apps.apple.com/fr/app/workout-history/id6448888087',
      pt: 'https://apps.apple.com/pt/app/workout-history/id6448888087',
      'zh-TW': 'https://apps.apple.com/tw/app/workout-history/id6448888087',
      it: 'https://apps.apple.com/it/app/workout-history/id6448888087',
      id: 'https://apps.apple.com/id/app/workout-history/id6448888087',
      th: 'https://apps.apple.com/th/app/workout-history/id6448888087',
      ar: 'https://apps.apple.com/sa/app/workout-history/id6448888087',
      jp: 'https://apps.apple.com/jp/app/workout-history/id6448888087',
      kr: 'https://apps.apple.com/kr/app/workout-history/id6448888087',
    },
  },
  {
    text: 'googlePlay',
    links: {
      en: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      de: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      es: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      fr: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      pt: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      'zh-TW':
        'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      it: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      id: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      th: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      ar: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      jp: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
      kr: 'https://play.google.com/store/apps/details?id=com.suhwanlim.aitrainer',
    },
  },
  //   {
  //     text: 'Podręczniki',
  //     link: 'books',
  //     corename: 'books',
  //     image: 'books',
  //   },
  //   {
  //     text: 'Statystyki',
  //     link: 'statistics',
  //     corename: 'statistics',
  //     image: 'statistics',
  //   },
  //   {
  //     text: 'Informacje',
  //     link: 'info',
  //     corename: 'info',
  //     image: 'info',
  //   },
]
